export default "__VITE_ASSET__TqpezXOy__"